"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vgm = require("@/api/query/vgm");
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'containerInfo',
  data: function data() {
    return {
      loading: false,
      isResult: false,
      form: {
        containers: ''
      },
      rules: {
        containers: [{
          required: true,
          message: this.$t('validate.containerNo'),
          trigger: 'blur'
        }]
      },
      vgmData: []
    };
  },
  created: function created() {},
  methods: {
    validateNull: _validate.validateNull,
    toSearch: function toSearch() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.loading = (0, _utils.load)();
          (0, _vgm.getVgmByContainers)(_this.form).then(function (response) {
            if (!(0, _validate.validateNull)(response.data)) {
              var data = response.data;
              _this.vgmData = data;
              _this.isResult = true;
            } else {
              _this.vgmData = [];
              _this.isResult = true;
            }
          }).catch(function () {
            _this.vgmData = [];
            _this.isResult = true;
          }).finally(function () {
            _this.loading.close();
          });
        }
      });
    }
  }
};